/*
 * NicheCanvas — Delivery estimate widget inside the UpCart drawer.
 * "Get it by <date range>" (now+8 to now+11 days), mirrors the PDP widget in
 * sections/product-header.liquid. Injected once, above the checkout button.
 * Pale-green reassurance styling + green check (matches the free-shipping cue).
 */
(function () {
  'use strict';

  function root() { return window.upcartDocumentOrShadowRoot || null; }

  function fmt(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: '2-digit' });
  }
  function range() {
    var now = new Date();
    return fmt(new Date(now.getTime() + 8 * 86400000)) + ' - ' + fmt(new Date(now.getTime() + 11 * 86400000));
  }

  var SVG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2E7D32" stroke-width="2.4" stroke-linejoin="round" stroke-linecap="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';

  function ensureStyle() {
    var r = root(); if (!r || r.querySelector('#nc-delivery-style')) return;
    var st = document.createElement('style');
    st.id = 'nc-delivery-style';
    st.textContent = '.nc-delivery{display:flex;align-items:center;justify-content:center;gap:6px;font-size:12px;color:#3B6B43;margin:0 0 10px;padding:9px;background:#E8F5E9;border:1px solid #C8E6C9;}'
      + '.nc-delivery b{font-weight:800;color:#1B5E20;}'
      + '.nc-delivery svg{flex:none;}';
    r.appendChild(st);
  }

  function inject() {
    var r = root(); if (!r) return;
    if (r.querySelector('.nc-delivery')) return;
    var anchor = r.querySelector('.upcart-checkout-button-container');
    if (!anchor || !anchor.parentNode) return;
    ensureStyle();
    var el = document.createElement('div');
    el.className = 'nc-delivery';
    el.innerHTML = SVG + ' Get it by <b>' + range() + '</b>';
    anchor.parentNode.insertBefore(el, anchor);
  }

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(inject, 150); }

  function start() {
    var r = root(); if (!r) return false;
    try { new MutationObserver(schedule).observe(r, { childList: true, subtree: true }); } catch (e) {}
    ['upcartSubscribeCartLoaded', 'upcartSubscribeCartUpdated', 'upcartSubscribeCartOpened'].forEach(function (fn) {
      if (typeof window[fn] === 'function') { try { window[fn](schedule); } catch (e) {} }
    });
    schedule();
    return true;
  }

  var n = 0;
  var poll = setInterval(function () {
    if (window.upcartDocumentOrShadowRoot && start()) { clearInterval(poll); return; }
    if (++n > 100) clearInterval(poll);
  }, 300);
})();
